module.exports = __webpack_public_path__ + "img/hero.8e395f31.jpg";